import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Contractdetails',
  tabs: {
    [info_tab]: 'Info',
    [contract_tab]: 'Contract',
    [versioning_tab]: 'Versiebeheer',
  },
  sections: {
    price_info: 'Prijsinfo',
    contact: 'Huidig contract',
    signature_history: 'Ondertekeningshistorie',
  },
  labels: {
    not_signed: 'Contract is nog niet ondertekend',
  },
  modals: {
    preview_contract: {
      title: 'Contract bekijken',
    },
    switch_to_annual: {
      title: 'Overschakelen naar jaarlijks',
    },
  },
  buttons: {
    save: 'Opslaan',
    preview_and_sign: 'Bekijken en ondertekenen',
    download: 'Downloaden',
    switch_to_annual: 'Overschakelen naar jaarlijks',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
